import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import ButtonContained from "../components/ButtonPrimaryContained";
import ButtonOutlined from "../components/ButtonPrimaryOutlined";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { useDispatch } from "react-redux";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TextField from "@mui/material/TextField";
import { Input, InputLabel } from "@mui/material";

export default function EditForm({
  onClose,
  showEditModal,
  table,
  selectedRow,
  action,
  username,
  hasTitle = false,
  hasDescription = false,
  hasFeaturesTitle = false,
  hasImage = false,
  hasFeaturesImage = false,
  hasVideo = false,
  hasEmail = false,
  hasPhone = false,
  hasAddress = false,
}) {
  const dispatch = useDispatch();
  const [titleImage, setTitleImage] = useState("");
  const [titleImagePreview, setTitleImagePreview] = useState("");
  const [featuresImage, setFeaturesImage] = useState("");
  const [featuresImagePreview, setFeaturesImagePreview] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleAr, setTitleAr] = useState("");
  const [descriptionEn, setDescriptionEn] = useState("");
  const [descriptionAr, setDescriptionAr] = useState("");
  const [featureTitleEn, setFeatureTitleEn] = useState("");
  const [featureTitleAr, setFeatureTitleAr] = useState("");
  const [features, setFeatures] = useState("");

  useEffect(() => {
    if (titleImage) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setTitleImagePreview(reader.result);
      };
      reader.readAsDataURL(titleImage);
    }
  }, [titleImage]);

  useEffect(() => {
    if (featuresImage) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFeaturesImagePreview(reader.result);
      };
      reader.readAsDataURL(featuresImage);
    }
  }, [featuresImage]);

  const handleTitleImageSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setTitleImage(file);
    }
  };

  const handleFeaturesImageSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFeaturesImage(file);
    }
  };

  const handleClose = () => {
    setTitleImage("");
    setTitleImagePreview("");
    setFeaturesImage("");
    setFeaturesImagePreview("");
    onClose();
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("table", table);
    formData.append("id", selectedRow?.id);

    if (titleEn || titleAr !== "") {
      const titleObject = {
        en: titleEn !== "" ? titleEn : selectedRow?.TitleEn,
        ar: titleAr !== "" ? titleAr : selectedRow?.TitleAr,
      };
      formData.append("title", JSON.stringify(titleObject));
    }

    if (descriptionEn || descriptionAr !== "") {
      const descriptionObject = {
        en: descriptionEn !== "" ? descriptionEn : selectedRow?.DescriptionEn,
        ar: descriptionAr !== "" ? descriptionAr : selectedRow?.DescriptionAr,
      };
      formData.append("description", JSON.stringify(descriptionObject));
    }

    if (titleImage !== "") {
      formData.append("image", titleImage);
    }

    if (featuresImage !== "") {
      formData.append("featureImage", featuresImage);
    }

    if (featureTitleEn || featureTitleAr !== "") {
      const featureTitleObject = {
        en:
          featureTitleEn !== "" ? featureTitleEn : selectedRow?.FeatureTitleEn,
        ar:
          featureTitleAr !== "" ? featureTitleAr : selectedRow?.FeatureTitleAr,
      };
      formData.append("featureTitle", JSON.stringify(featureTitleObject));
    }

    if (features !== "") {
      formData.append("features", JSON.stringify(features));
    }
    formData.append("username", username);
    dispatch(action(formData));

    setTitleImage("");
    setFeaturesImage("");
    setTitleImagePreview("");
    setFeaturesImagePreview("");
    onClose();
  };

  return (
    <Modal
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      open={showEditModal}
      onClose={handleClose}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "2em",
          maxHeight: "100%",
          overflowY: "auto",
        }}
      >
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Edit row {selectedRow?.id} in {table}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1em",
          }}
        >
          {hasImage && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "1em",
              }}
            >
              <InputLabel>Title Image</InputLabel>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                  <InputLabel
                    htmlFor="title-image-upload"
                    style={{ cursor: "pointer" }}
                  >
                    <CloudUploadIcon color="primary" />
                    <Input
                      id="title-image-upload"
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleTitleImageSelect}
                    />
                  </InputLabel>
                }
              >
                <Avatar
                  alt=""
                  src={
                    titleImagePreview !== ""
                      ? titleImagePreview
                      : selectedRow?.image
                  }
                  sx={{ width: "100px", height: "100px" }}
                />
              </Badge>
            </Box>
          )}

          {hasFeaturesImage && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "1em",
              }}
            >
              <InputLabel>Features Image</InputLabel>
              <Badge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                  <InputLabel
                    htmlFor="features-image-upload"
                    style={{ cursor: "pointer" }}
                  >
                    <CloudUploadIcon color="primary" />
                    <Input
                      id="features-image-upload"
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFeaturesImageSelect}
                    />
                  </InputLabel>
                }
              >
                <Avatar
                  alt=""
                  src={
                    featuresImagePreview !== ""
                      ? featuresImagePreview
                      : selectedRow?.featureImage
                  }
                  sx={{ width: "100px", height: "100px" }}
                />
              </Badge>
            </Box>
          )}
        </Box>

        {hasTitle && (
          <>
            <TextField
              required
              id="outlined-required"
              label="Title En"
              defaultValue={selectedRow?.TitleEn}
              onChange={(event) => setTitleEn(event.target.value)}
            />
            <TextField
              required
              id="outlined-required"
              label="Title Ar"
              defaultValue={selectedRow?.TitleAr}
              onChange={(event) => setTitleAr(event.target.value)}
            />
          </>
        )}

        {hasDescription && (
          <>
            <TextField
              required
              id="outlined-multiline-static"
              label="Description En"
              multiline
              rows={4}
              defaultValue={selectedRow?.DescriptionEn}
              onChange={(event) => setDescriptionEn(event.target.value)}
            />
            <TextField
              required
              id="outlined-multiline-static"
              label="Description Ar"
              multiline
              rows={4}
              defaultValue={selectedRow?.DescriptionAr}
              onChange={(event) => setDescriptionAr(event.target.value)}
            />
          </>
        )}

        {hasFeaturesTitle && (
          <>
            <TextField
              required
              id="outlined-required"
              label="Features Title En"
              defaultValue={selectedRow?.FeatureTitleEn}
              onChange={(event) => setFeatureTitleEn(event.target.value)}
            />
            <TextField
              required
              id="outlined-required"
              label="Features Title Ar"
              defaultValue={selectedRow?.FeatureTitleAr}
              onChange={(event) => setFeatureTitleAr(event.target.value)}
            />
          </>
        )}

        {/* <TextField
          required
          id="outlined-required"
          label="Features"
          defaultValue={selectedRow?.features}
          onChange={(event) =>
            setFeatures(
              event.target.value.split(",").map((item) => item.trim())
            )
          }
        /> */}
        <Box style={{ display: "flex", gap: "1em" }}>
          <ButtonContained
            onClick={handleSubmit}
            label="Submit"
          ></ButtonContained>
          <ButtonOutlined onClick={handleClose} label="Close"></ButtonOutlined>
        </Box>
      </Box>
    </Modal>
  );
}
